const transformSOVGatewayData = _gateways => {
    // Transform data from API response to type-ahead data format
    let data = [];

    _gateways?.forEach(gateway => {
        data.push({
            value: gateway.code,
            label: gateway.name,
            heading: gateway.location.split(",")[0],
            search: gateway.location,
            id: gateway.name,
        });
    });

    // Sort gateways by location
    data = data.sort((a, b) => {
        const sortMethod = (a.heading > b.heading) - (b.heading > a.heading);
        return sortMethod;
    });

    const flatArray = [...data];

    // Remove duplicate headings
    let previousGateway = null;
    flatArray?.forEach(gateway => {
        if (gateway.search === previousGateway) {
            // eslint-disable-next-line no-param-reassign
            gateway.heading = "";
        }

        previousGateway = gateway.search;
    });

    const exportArray = [];
    let tempArray = [];
    let heading = "";
    let previousHeading = "";

    flatArray?.forEach(faItem => {
        if (previousHeading !== faItem.heading && faItem.heading !== "") {
            // Save the last group
            exportArray.push({
                title: heading,
                search: heading,
                items: [...tempArray],
            });

            // Reset temp vars
            tempArray = [];

            // Start the new group
            heading = faItem.heading;
        }

        tempArray.push(faItem);

        previousHeading = faItem.heading;
    });

    // Handle last array item
    exportArray.push({
        title: heading,
        search: heading,
        items: [...tempArray],
    });

    return exportArray.filter(array => array.items.length > 0);
};

export { transformSOVGatewayData };
export default transformSOVGatewayData